(function () {
  var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isTouch = window.matchMedia && window.matchMedia('(hover: none), (pointer: coarse)').matches;

  document.querySelectorAll('[data-hero]').forEach(function (hero) {
    var video = hero.querySelector('[data-hero-video]');
    if (video) {
      if (prefersReducedMotion) {
        video.pause();
        video.removeAttribute('autoplay');
      } else if ('IntersectionObserver' in window) {
        // pause offscreen to save battery/bandwidth, resume when hero is back in view
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              video.play().catch(function () {});
            } else {
              video.pause();
            }
          });
        }, { threshold: 0.1 });
        io.observe(video);
      }
    }

    var aura = hero.querySelector('[data-hero-aura]');

    if (aura && !prefersReducedMotion && !isTouch) {
      hero.addEventListener('mousemove', function (e) {
        var rect = hero.getBoundingClientRect();
        var x = ((e.clientX - rect.left) / rect.width) * 100;
        var y = ((e.clientY - rect.top) / rect.height) * 100;
        aura.style.setProperty('--ax', x + '%');
        aura.style.setProperty('--ay', y + '%');
      });
    }

    var parallaxEl = hero.querySelector('[data-hero-parallax]');
    if (parallaxEl && !prefersReducedMotion && !isTouch) {
      hero.addEventListener('mousemove', function (e) {
        var rect = hero.getBoundingClientRect();
        var relX = (e.clientX - rect.left) / rect.width - 0.5;
        var relY = (e.clientY - rect.top) / rect.height - 0.5;
        parallaxEl.style.transform = 'translate(' + (relX * 14) + 'px, ' + (relY * 10) + 'px)';
      });
      hero.addEventListener('mouseleave', function () {
        parallaxEl.style.transform = '';
      });
    }
  });

  if (!prefersReducedMotion && !isTouch) {
    document.querySelectorAll('[data-magnetic]').forEach(function (btn) {
      btn.addEventListener('mousemove', function (e) {
        var r = btn.getBoundingClientRect();
        var relX = e.clientX - r.left - r.width / 2;
        var relY = e.clientY - r.top - r.height / 2;
        btn.style.transform = 'translate(' + relX * 0.15 + 'px, ' + relY * 0.3 + 'px)';
      });
      btn.addEventListener('mouseleave', function () {
        btn.style.transform = '';
      });
    });
  }
})();
